import { render, staticRenderFns } from "./PluginEdition.vue?vue&type=template&id=2a2183e6"
import script from "./PluginEdition.vue?vue&type=script&lang=js"
export * from "./PluginEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports